// This route is used for the review page, which has a backdoor entrance.

import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const JwtRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      sessionStorage.jwt
        ? <Component {...props} />
        : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    )}
  />
);

export default JwtRoute;



// WEBPACK FOOTER //
// ./src/components/common/JwtRoute.js